import { Attachment } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Vector3Tuple } from 'three';
import EntityApi, { BaseEntity } from './EntityApi';

export enum MapType {
	BASE = 'BASE',
	ROUGHNESS = 'ROUGHNESS',
	NORMAL = 'NORMAL',
	HEIGHT = 'HEIGHT',
	METALLNESS = 'METALLNESS',
	AO = 'AO',
	LIGHT = 'LIGHT',
}

export enum AssetType {
	MATERIAL = 'MATERIAL',
	MODEL = 'MODEL',
}

export type AssetOptions = {
	blockLayout: Vector3Tuple[];
};

export interface Asset extends BaseEntity {
	name: string;
	model?: Attachment;
	type: AssetType;
	maps: Record<MapType, Attachment | null>;
	options: AssetOptions;
}

class AssetApi extends EntityApi<Asset> {
	constructor() {
		super(ApiQueryKey.assets);
	}
}

export default new AssetApi();
